import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineLayersIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m2.5 10.56 8.9999 5.2a1 1 0 0 0 1 0l9-5.2a.9994.9994 0 0 0 .4983-.865.9994.9994 0 0 0-.4983-.865l-9-5.2a.9998.9998 0 0 0-1 0l-9 5.2a1 1 0 0 0 0 1.73Zm9.4999-4.91 7 4-7 4.05-7-4.01 7-4.04Zm8.5 7.79-8.5 4.91-8.5-4.91a1.0003 1.0003 0 0 0-1.37.36.9996.9996 0 0 0 .0742 1.113 1 1 0 0 0 .2959.257l8.9999 5.2a1 1 0 0 0 1 0l9-5.2a1.0006 1.0006 0 0 0 .4702-.608.9994.9994 0 0 0-.1002-.762.9987.9987 0 0 0-.6102-.4644 1.0012 1.0012 0 0 0-.7598.1044Z"/>
  </SvgIcon>
}

export default LineLayersIcon
